import { Box, Button, TextField } from '@mui/material'
import { useEffect, useState } from 'react'

import { useAppContext } from '@/hooks'
import { BranchSection } from '@/pages/User/pages/Branches/components/BranchDetailUi'

import { DeploymentPackageRecord } from '../types'

type PackageInfoSectionProps = {
	canEdit: boolean
	isSaving: boolean
	onSave: (values: { description: string; name: string }) => void
	pkg: DeploymentPackageRecord
}

const fieldSx = {
	'& .MuiInputBase-root': { borderRadius: '9px', fontSize: 13 },
	'& .MuiInputLabel-root': { fontSize: 13 },
}

export const PackageInfoSection = ({
	canEdit,
	isSaving,
	onSave,
	pkg,
}: PackageInfoSectionProps) => {
	const { t } = useAppContext()
	const [name, setName] = useState(pkg.name)
	const [description, setDescription] = useState(pkg.description)

	useEffect(() => {
		setName(pkg.name)
		setDescription(pkg.description)
	}, [pkg.description, pkg.name])

	const isDirty = name.trim() !== pkg.name || description.trim() !== pkg.description

	return (
		<BranchSection title={t('DEPLOYMENT_PACKAGES_INFO')}>
			<Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { md: '1fr 2fr', xs: '1fr' } }}>
				<TextField
					size="small"
					label={t('DEPLOYMENT_PACKAGES_NAME')}
					value={name}
					disabled={!canEdit}
					onChange={(event) => setName(event.target.value)}
					data-testid="deployment-package-detail-name"
					sx={fieldSx}
				/>
				<TextField
					size="small"
					label={t('DESCRIPTION')}
					value={description}
					disabled={!canEdit}
					multiline
					maxRows={4}
					onChange={(event) => setDescription(event.target.value)}
					data-testid="deployment-package-detail-description"
					sx={fieldSx}
				/>
			</Box>
			{canEdit && isDirty ? (
				<Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 1.5 }}>
					<Button
						onClick={() => {
							setName(pkg.name)
							setDescription(pkg.description)
						}}
						sx={{ textTransform: 'none' }}
					>
						{t('CANCEL')}
					</Button>
					<Button
						variant="contained"
						disableElevation
						disabled={!name.trim() || isSaving}
						onClick={() => onSave({ description: description.trim(), name: name.trim() })}
						data-testid="deployment-package-detail-save"
						sx={{ borderRadius: '8px', textTransform: 'none' }}
					>
						{t('SAVE')}
					</Button>
				</Box>
			) : null}
		</BranchSection>
	)
}
